import { render, staticRenderFns } from "./PageInfoHeader.vue?vue&type=template&id=6781faea&scoped=true&"
import script from "./PageInfoHeader.vue?vue&type=script&lang=js&"
export * from "./PageInfoHeader.vue?vue&type=script&lang=js&"
import style0 from "./PageInfoHeader.vue?vue&type=style&index=0&id=6781faea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6781faea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6781faea')) {
      api.createRecord('6781faea', component.options)
    } else {
      api.reload('6781faea', component.options)
    }
    module.hot.accept("./PageInfoHeader.vue?vue&type=template&id=6781faea&scoped=true&", function () {
      api.rerender('6781faea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/PageInfoHeader.vue"
export default component.exports